import { render, staticRenderFns } from "./LayoutContentUsers.vue?vue&type=template&id=716473ce&scoped=true"
import script from "./LayoutContentUsers.vue?vue&type=script&lang=js"
export * from "./LayoutContentUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716473ce",
  null
  
)

export default component.exports